(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao')
    .controller('AbaFeitosVistaAberta', AbaFeitosVistaAberta);

  function AbaFeitosVistaAberta(GlosaService, ParametroService, $state) {

    var vm = this;

    vm.init = init;

    vm.loadRegistros = loadRegistros;

    vm.isFeitosGlosados = isFeitosGlosados;
    vm.isFeitosPendentes = isFeitosPendentes;
    vm.camposPendentesDeclarados = camposPendentesDeclarados;
    vm.periodoSelecionado = $state.params.periodoSelecionado;

    vm.totalReconhecidosPeloMembroCalculado = 0;

    vm.init();

    function init() {
      vm.promotorSelecionado = $state.params.promotorSelecionado;
      vm.relDkSelecionado = $state.params.relDkSelecionado;
      vm.loadRegistros();

      ParametroService.getLimiteDiasFeitosVistaAberta(vm.periodoSelecionado).then(function (data) {
        vm.parametro = data;
      });
    }

    function loadRegistros() {

      vm.registrosList = {};

      GlosaService.getFeitosAbertosMais30Dias(vm.promotorSelecionado.originalObject.pessDk,
        vm.relDkSelecionado).then(function (data) {
        vm.registrosList = data;
        atualizaTotalReconhecido();
      });
    }

    function atualizaTotalReconhecido() {
        vm.totalReconhecidosPeloMembroCalculado =
          vm.registrosList.totalReconhecidosPeloMembro +
          (isNaN(vm.registrosList.quantidadeVistaAbertaDeclarada) ? 0 : vm.registrosList.quantidadeVistaAbertaDeclarada);
    }

    function isFeitosGlosados() {
      return vm.registrosList.totalFeitosOrigemMGP !== vm.registrosList.totalReconhecidosPeloMembro;
    }

    function isFeitosPendentes() {
      return vm.registrosList.totalReconhecidosPeloMembro !== 0;
    }

    function camposPendentesDeclarados() {
      var isQuantidadePresente = ((
        vm.registrosList.quantidadeVistaAbertaDeclarada !== null &&
          vm.registrosList.quantidadeVistaAbertaDeclarada !== "") &&
          vm.registrosList.quantidadeVistaAbertaDeclarada >= 0
      );

      var isJustificativaPresente = (
        vm.registrosList.justificativaVistaAbertaDeclarada !== null &&
        vm.registrosList.justificativaVistaAbertaDeclarada !== ""
      );

      return isQuantidadePresente !== isJustificativaPresente;
    }

  }

})();
